import styles from './style.module.scss';
import {Box, Button, Typography} from '@mui/material';
import {t} from 'i18next';
import {RefObject} from 'react';
import {AskLioRecommnededQuestion} from '../../types/ask-lio/askLioTypes';

type AurAskLioPromptLabel = {
  show: boolean;
  scrollableContainerRef: RefObject<HTMLElement>;
  questions: AskLioRecommnededQuestion[];
  onHandleSend: (query: string) => void;
};

const AurAskLioRecommnededQuestion: React.FC<AurAskLioPromptLabel> = ({
  show,
  scrollableContainerRef,
  questions,
  onHandleSend,
}) => {
  if (show && questions?.length) {
    const lastChatIndex = questions.length - 1;
    return (
      <>
        <Box className={`${styles.aurBoxStart}`}>
          <Typography className={`${styles.aurAskLioPromptLabel}`}>
            {t('askLio.AskLioPromptlabel')}
          </Typography>
        </Box>
        {questions?.map((item, index) => (
          <Box
            className={`${styles.aurBoxStart}`}
            key={item.questionId}
            {...(lastChatIndex === index ? {ref: scrollableContainerRef} : {})}
          >
            <Button
              className={`${styles.aurSuggestionBoxQuery} ${styles.aurQuerySolidBorder}`}
              onClick={() => {
                onHandleSend(item.question);
              }}
            >
              <Typography className={`${styles.aurAskLioSuggestedQuestiont}`}>
                {item.question}
              </Typography>
            </Button>
          </Box>
        ))}
      </>
    );
  } else {
    return null;
  }
};

export default AurAskLioRecommnededQuestion;
